import { render } from "./property-poirecord.vue?vue&type=template&id=75ba59b9"
import script from "./property-poirecord.js?vue&type=script&lang=js"
export * from "./property-poirecord.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__